
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { Employee_$reflection } from "../../../Shared/User.js";
import { union_type, class_type, record_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { AccountSettings_$reflection, CustomerConfiguration_$reflection, RequestedValue$1_$reflection } from "../../../Shared/Shared.js";
import { PropertyConfiguration_$reflection } from "../../../Shared/PropertyConfiguration.js";
import { Location_$reflection } from "../../../Shared/Location.js";

export class State extends Record {
    constructor(Employees, CustomerConfiguration, PropertyConfigurations, Locations, AccountSettings) {
        super();
        this.Employees = Employees;
        this.CustomerConfiguration = CustomerConfiguration;
        this.PropertyConfigurations = PropertyConfigurations;
        this.Locations = Locations;
        this.AccountSettings = AccountSettings;
    }
}

export function State_$reflection() {
    return record_type("ToolBox.Overviews.Employee.Types.State", [], State, () => [["Employees", RequestedValue$1_$reflection(list_type(Employee_$reflection()))], ["CustomerConfiguration", RequestedValue$1_$reflection(CustomerConfiguration_$reflection())], ["PropertyConfigurations", RequestedValue$1_$reflection(list_type(PropertyConfiguration_$reflection()))], ["Locations", RequestedValue$1_$reflection(list_type(Location_$reflection()))], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AccountSettingsFetched", "CustomerConfigurationFetched", "EmployeesFetched", "PropertyConfigurationsFetched", "LocationsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("ToolBox.Overviews.Employee.Types.Msg", [], Msg, () => [[["Item", AccountSettings_$reflection()]], [["Item", CustomerConfiguration_$reflection()]], [["Item", list_type(Employee_$reflection())]], [["Item", list_type(PropertyConfiguration_$reflection())]], [["Item", list_type(Location_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

